/* eslint-disable consistent-return, no-setter-return */
const SessionObject = Object.create(
  {},
  {
    shop: {
      configurable: true,
      writable: true,
      value: '',
    },
    tenant: {
      configurable: true,
      enumerable: true,
      get() {
        const tenant = localStorage.getItem(`${this.shop}-tenant`);
        try {
          return JSON.parse(tenant);
        } catch (err) {
          return null;
        }
      },
      set(value) {
        if (!value) {
          return localStorage.removeItem(`${this.shop}-tenant`);
        }
        localStorage.setItem(`${this.shop}-tenant`, JSON.stringify(value));
      },
    },
    session: {
      configurable: true,
      enumerable: true,
      set(value) {
        if (!value) {
          return localStorage.removeItem(`${this.shop}-session`);
        }
        localStorage.setItem(`${this.shop}-session`, JSON.stringify(value));
      },
      get() {
        return JSON.parse(localStorage.getItem(`${this.shop}-session`));
      },
    },
    hasOldSession: {
      configurable: true,
      enumerable: true,
      set(value) {
        if (!value) {
          localStorage.removeItem(`${this.shop}-sessionId`);
        }
      },
      get() {
        return localStorage.getItem(`${this.shop}-sessionId`);
      },
    },
  }
);

export default SessionObject;
